import { render, staticRenderFns } from "./EWLimitConfigList.vue?vue&type=template&id=1ad90347&"
import script from "./EWLimitConfigList.vue?vue&type=script&lang=js&"
export * from "./EWLimitConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports